import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const ComparisonInfoDtoSchema = z.object({
  message: z.string().optional(),
  facilitiesCount: z.number(),
  avgOccupancy: z.number().nullable(),
  topPerformingFacility: z
    .object({
      name: z.string(),
      occupancy: z.number().nullable(),
    })
    .nullable(),
  bottomPerformingFacility: z
    .object({
      name: z.string(),
      occupancy: z.number().nullable(),
    })
    .nullable(),
  portfolioPotentialRevenueLoss: z.number().nullable(),
});

export const GetComparisonInfoRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

export const GetComparisonInfoResponseDtoSchema = ComparisonInfoDtoSchema;

export type ComparisonInfoDto = z.infer<typeof ComparisonInfoDtoSchema>;

export type GetComparisonInfoRequestDto = z.infer<
  typeof GetComparisonInfoRequestDtoSchema
>;

export type GetComparisonInfoResponseDto = z.infer<
  typeof GetComparisonInfoResponseDtoSchema
>;

export const getComparisonInfo = async (
  params: GetComparisonInfoRequestDto,
  config?: AxiosRequestConfig<GetComparisonInfoRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/comparison-info`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetComparisonInfoResponseDtoSchema));
};
